import React from "react";

import { useQuery } from "@apollo/client";

import { loader } from "graphql.macro";

import TrendTable from "./trend-table-mui";
// import TrendTableDx from "./trend-table-dx";
// import TrendTableZingGrid from './trend-table-zinggrid';

import { allData as allDataFn } from "./trend-graph-utils";

const TrendMetaData = loader("../graphql/TrendMetaData.graphql");

// const TrendValues = loader("../graphql/TrendValues.graphql");

interface Props {
  nodes?: any[];
  panelId?: string;
  startDate: number; // Date;
  endDate: number; // Date;
  widgetStatic?: boolean;
  widgetTitle?: string;
}

// FIXME Use paginated datasource, not the one for charts!
function TrendTableContainer(props: Props) {
  // startDate={data.durationSelect && data.durationSelect.startDate || '2010-01-01T00:00:00.00Z'} endDate={data.durationSelect && data.durationSelect.endDate || '2020-01-01T00:00:00.00Z'}
  const {
    nodes,
    panelId,
    startDate,
    endDate,
    widgetStatic,
    widgetTitle,
  } = props;
  const n = nodes ? nodes.map((n) => n.id).join(",") : undefined;
  const { data, error: metaError, loading: metaLoading } = useQuery(
    TrendMetaData,
    {
      variables: { panel: panelId, nodes: n },
    }
  );
  // const {
  //   data: dataSeries,
  //   error: valuesError,
  //   loading: valuesLoading,
  // } = useQuery(TrendValues, {
  //   variables: { panelId, nodes: n, startDate, endDate },
  // });
  if (metaLoading) {
    return <div>Loading...</div>;
  }
  if (metaError) {
    console.error(metaError.message);
    return <div>Error! {metaError.message}</div>;
  }
  // if (valuesLoading) {
  //   return <div>Loading...</div>;
  // }
  // if (valuesError) {
  //   console.error(valuesError.message);
  //   return <div>Error! {valuesError.message}</div>;
  // }

  const allData = allDataFn(data.metaData);
  // const chartData = mergeSeries(dataSeries.dataSeries).sort(
  //   (a, b) => b.time - a.time
  // );
  return (
    <TrendTable
      // nodes={nodes}
      allData={allData}
      metaData={data.metaData}
      // chartData={chartData}
      // dataSeries={dataSeries.dataSeries}
      widgetStatic={widgetStatic}
      widgetTitle={widgetTitle}
      nodes={nodes}
      panelId={panelId}
      startDate={startDate}
      endDate={endDate}
    />
  );
}

export default TrendTableContainer;
